import MDCGroupNotification from "../../core/MDCGroupNotification";
import { Grid } from "@mui/material";

const StatusServiceMessages = (props) => {
  const { statusServiceData, showMessageDetailDialog } = props;

  return (
    <>
      {statusServiceData?.length ? (
        <Grid maxHeight={"11.80rem"} overflow={"auto"}>
          {statusServiceData?.map((bannerInfo, index) => (
            <MDCGroupNotification
              key={index}
              groupBannerData={bannerInfo}
              showMessageDetailDialog={showMessageDetailDialog}
            />
          ))}
        </Grid>
      ) : (
        <></>
      )}
    </>
  );
};

export default StatusServiceMessages;
